/** Query opens learner home and enables session so staff stay in learner view while navigating. */
export const LEARNER_HOME_PREVIEW_PATH = "/?learner_preview=1";

/** Content creator hub (programs list). */
export const COMPOSER_HOME_PATH = "/composer";

const SESSION_KEY = "arrows_learner_view_mode";

export function setLearnerViewModeActive() {
  try {
    sessionStorage.setItem(SESSION_KEY, "1");
  } catch (_e) {
    /* ignore */
  }
}

export function clearLearnerViewMode() {
  try {
    sessionStorage.removeItem(SESSION_KEY);
  } catch (_e) {
    /* ignore */
  }
}

export function isLearnerViewModeActive() {
  try {
    return sessionStorage.getItem(SESSION_KEY) === "1";
  } catch (_e) {
    return false;
  }
}

export function shouldSkipLearnerHomeAdminRedirect(search) {
  if (new URLSearchParams(search || "").get("learner_preview") === "1") return true;
  return isLearnerViewModeActive();
}

/** Routes where the learner (non-composer) experience runs for end users. */
export function isLearnerExperiencePath(pathname) {
  if (!pathname) return false;
  if (pathname === "/") return true;
  if (pathname.startsWith("/course")) return true;
  if (pathname.startsWith("/info-page")) return true;
  if (pathname.startsWith("/session")) return true;
  if (pathname.startsWith("/scenario")) return true;
  return false;
}
